import { styled } from '@mui/system'
import FacebookIcon from '@mui/icons-material/Facebook'
import { Colors } from 'constants/colors'
import TwitterIcon from '@mui/icons-material/Twitter'
import InstagramIcon from '@mui/icons-material/Instagram'
import RedditIcon from '@mui/icons-material/Reddit'
import YouTubeIcon from '@mui/icons-material/YouTube'
import { ReactComponent as TikTokIcon } from './tiktok.svg'
const FacebookIconStyle = styled(FacebookIcon)({
  margin: '0 5px 0 0',
  fontSize: '22px',
  padding: 0,
  color: Colors.deepBlue,
})
const InstagramIconStyle = styled(InstagramIcon)({
  margin: '0 5px 0 0',
  fontSize: '22px',

  padding: 0,
  color: Colors.pink,
})

const RedditIconStyle = styled(RedditIcon)({
  fontSize: '22px',
  margin: '0 5px 0 0',
  padding: 0,
  color: Colors.orangeRed,
})

const YoutubeIconStyle = styled(YouTubeIcon)({
  fontSize: '22px',
  margin: '0 5px 0 0',
  padding: 0,
  color: Colors.strongRed,
})

const TwitterIconStyle = styled(TwitterIcon)({
  fontSize: '22px',
  margin: '0 5px 0 0',
  padding: 0,
  color: Colors.lightBlue,
})
const TikTokIconStyle = styled(TikTokIcon)({
  margin: '0 5px 0 0',
  padding: 0,
  color: Colors.black,
})

const IconStyle = {
  FacebookIconStyle,
  InstagramIconStyle,
  TwitterIconStyle,
  RedditIconStyle,
  YoutubeIconStyle,
  TikTokIconStyle,
}

export default IconStyle
